import moment from "moment";

export function dateFormat(date, format) {
  return date ? moment(date).format(format ? format : "YYYY-MM-DD") : null;
}
export function timeFormat(time, format) {
  return time
    ? moment(time, "HH:mm:ss").format(format ? format : "hh:mmA")
    : null;
}
export function generateUniqueSlug(name, existingSlugs) {
  // Transform the name to a lowercase hyphen-separated base slug
  let baseSlug = name.toLowerCase().replace(/\s+/g, "-");
  let slug = baseSlug;
  let count = 1;

  // Check if slug already exists in the existingSlugs array
  while (existingSlugs.includes(slug)) {
    count++;
    slug = `${baseSlug}-${count}`;
  }

  return slug;
}

export function formatTimeWithSeconds(time) {
  if (!time) return null; // Handle null or undefined cases

  const parts = time.split(":");
  if (parts.length === 2) {
    return `${time}:00`; // Append ":00" if seconds are missing
  }
  return time; // Return as is if already in HH:mm:ss format
}

export const downloadFile = (url, fileName) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.target = "_blank";
  link.click();
};

export const _ROUTES = {
  PROFILE: "/staff/profile",
  ATTENDANCE: "/staff/attendance",
  ASSIGNMENTS: "/staff/assignments",
  ASSIGNMENTS_ADD: "/staff/assignments/add",
  ASSIGNMENTS_EDIT: "/staff/assignments/edit",
  ASSIGNMENTS_VIEW: "/staff/assignments/view",
  COMMUNICATION: "/staff/communication",
  TIME_TABLE: "/staff/time-table",
  EXAMINATION: "/staff/examination",
  ACADAMICEXAMINATION: "/academic/exam-schedule",
  ACADEMICQUESTIONBANK: "/academic/question-bank",
  ACADEMICQUESTIONBANKADD: "/academic/question-bank/add",
  ACADEMICQUESTIONBANKEDIT: "/academic/question-bank/edit",
  ACADEMICQUESTIONBANKVIEW: "/academic/question-bank/view",
  ACADEMICQUESTIONPAPER: "/academic/question-paper",
  ACADEMICQUESTIONPAPERADD: "/academic/question-paper/add",
  ACADEMICQUESTIONPAPEREDIT: "/academic/question-paper/edit",
  ACADEMICQUESTIONPAPERVIEW: "/academic/question-paper/view",
  MANAGERESULT: "/staff/examination/manage-result",
  VIEWMANAGERESULT: "/staff/examination/manage-result/view",
  TRANSPORTATION: "/staff/transportation",
  DOCUMENTS: "/staff/documents",
  LEAVES: "/staff/leave",
  MEDICAL_RECORDS: "/staff/medical-records",
  NOTES: "/staff/notes",
  SALARY_PAYMENT: "/staff/salary-payment",
};

export const _STUDENT_ROUTES = {
  PROFILE: "/student/profile",
  ATTENDANCE: "/student/attendance",
  ASSIGNMENTS: "/student/assignments",
  TIME_TABLE: "/student/time-table",
  EXAMINATION: "/student/examination",
  TRANSPORTATION: "/student/transportation",
  DOCUMENTS: "/student/documents",
  MEDICAL_RECORDS: "/student/medical-records",
  NOTES: "/student/notes",
  FEE_FINES: "/student/fee-fines",
};

export const _FORM_MODULES = {
  STUDENT: "student",
  STAFF: "staff",
};

export const COMMON_PERMISSIONS = {
  CREATE: "create", // Permission to view resources
  VIEW: "view", // Permission to view resources
  UPDATE: "update", // Permission to edit or modify resources
  DELETE: "delete", // Permission to delete resources
};

export const USER_SPECIFIC_MODULES = {
  COMMUNICATION: "communication",
  COMMENT: "comment",
  CIRCULAR: "circular-management",
  LEAVE: "leave",
  MEDICAL_RECORD: "medical-record",
  HOUSE: "house",
  BORROWING: "borrowing",
  SYLLABUS: "syllabus",
  SYLLABUS_PROGRESS: "syllabus-progress",
  ONLINE_CLASS: "online-class",
  HOME_WORK: "home-work",
  GATE_PASS: "gate-pass",
  STAFF_ATTENDANCE: "staff-attendance",
  ASSIGNMENT: "assignment",
  ATTENDANCE: "attendance",
  HOLIDAY: "holiday",
  TIMETABLE: "timetable",
  EXAM: "exam",
  TRANSPORT: "transport",
  CERTIFICATE: "certificate",
  PAYROLL: "payroll",
  FEE: "fee-receipt",
  DOC_LOCKER: "doc-locker",
  PHOTOS: "file-manager",
};

export const MODULES_LIST = {
  COMMON: "common",
  BASIC_SETUP: "configuration",
  ACADEMIC: "academic",
  FEE_SETUP: "fee-setup",
  TRANSPORTATION: "transportation",
  EXAMINATION: "examination",
  PAYROLL: "payroll",
  INVENTORY: "inventory",
  COMMUNICATION: "communication",
  CONFIGURATION: "configuration",
  RECRUITMENT: "recruitment",
  HELP_CENTER: "help-center",
  MANAGE_GATE_TRACKING: "manage-gate-tracking",
  DOC_LOCKER: "doc-locker",
  PHOTOS: "file-manager",
};

export const SUB_MODULES_LIST = {
  DOC_LOCKER: {
    VIEW_DOC_LOCKER: "doc-locker",
  },
  PHOTOS: {
    VIEW_PHOTOS: "file-manager",
  },
  COMMON: {
    WORKSPACE: "workspace",
    NOTE: "note",
    CUSTOM_FIELD: "custom-field",
    COMMUNICATION: "communication",
    COMMENT: "comment",
    CIRCULAR: "circular-management",
    FILE_MANAGER: "file-manager",
  },
  BASIC_SETUP: {
    ROLE: "role",
    PERMISSION: "permission",
    USER: "user",
    STAFF: "staff",
    STAFF_ATTENDANCE: "staff-attendance",
    DEPARTMENT: "department",
    DESIGNATION: "designation",
    SESSION: "session",
    EDUCATION: "education",
    EXPERIENCE: "experience",
    CLASS: "class",
    SUBJECT: "subject",
    SECTION: "section",
    LEAVE_TYPE: "leave-type",
    LEAVE: "leave",
    MEDICAL_RECORD: "medical-record",
    SYLLABUS: "syllabus",
    SYLLABUS_PROGRESS: "syllabus-progress",
  },
  ACADEMIC: {
    PRE_ADMISSION_ENQUIRIES: "pre-admission-enquiries",
    STUDENT: "student",
    ATTENDANCE: "attendance",
    HOLIDAY: "holiday",
    ASSIGNMENT: "assignment",
    CONTACT: "contact",
    TIMETABLE: "timetable",
    TIMETABLE_REPLACEMENT: "timetable-replacement",
    BOOK: "book",
    BOOK_REQUEST: "book-request",
    BOOK_CATEGORY: "book-category",
    BORROWING: "borrowing",
    RESERVATION: "reservation",
    HOUSE: "house",
    STUDENT_HOUSE: "student-house",
    TERM: "term",
    EXAM_TYPE: "exam-type",
    EXAM: "exam",
    EXAM_RESULT: "exam-result",
    EXAM_MARKSHEET: "exam-marksheet",
    QUESTION_PAPER: "question-paper",
    QUESTION_BANK: "question-bank",
    CERTIFICATE: "certificate",
    ONLINE_CLASS: "online-class",
    HOME_WORK: "home-work",
  },
  EXAMINATION: {
    TERM: "term",
    EXAM_TYPE: "exam-type",
    EXAM: "exam",
    EXAM_RESULT: "exam-result",
    EXAM_MARKSHEET: "exam-marksheet",
    QUESTION_BANK: "question-bank",
    QUESTION_PAPER: "question-paper",
  },
  FEE_SETUP: {
    FEECYCLE: "feecycle",
    FEEHEAD: "feehead",
    FEEINVOICE: "feeinvoice",
    FEE_RECEIPT: "fee-receipt",
    FEE_COLLECT: "fee-collect",
    FEE_FINE: "fee-fine",
    INCIDENT_FINE: "incident-fine",
    CONCESSION: "concession",
    STUDENT_CONCESSION: "student-concession",
  },
  TRANSPORTATION: {
    VEHICLE: "vehicle",
    VEHICLE_FUEL_LOG: "vehicle-fuel-log",
    ROUTES: "routes",
    STOP: "stop",
    TRANSPORT_SCHEDULE: "transport-schedule",
    TRANSPORT_ATTENDANCE: "transport-attendance",
    DRIVER: "driver",
    HELPER: "transport-assistant",
    TRACKING: "tracking",
  },
  INVENTORY: {
    INVENTORY_CATEGORY: "inventory-category",
    STOCK: "stock",
    PURCHASE_REQUEST: "purchase-request",
    VENDOR: "vendor",
    PURCHASE_ORDER: "purchase-order",
    PURCHASE_ORDER_PAYMENT: "purchase-order-payment",
    PURCHASE_INVOICE: "purchase-invoice",
  },
  PAYROLL: {
    MANAGE_SALARY: "manage-salary",
    MANAGE_SALARY_REPORT: "manage-salary-report",
  },
  MANAGE_GATE_TRACKING: {
    GATE_PASS: "gate-pass",
    GATE_TRACKING: "gate-tracking",
  },
  HELP_CENTER: {
    MANAGE_HELP_CENTER: "manage-help-center",
  },
  RECRUITMENT: {
    JOB_OPENING: "job-opening",
    JOB_APPLICATION: "job-application",
    JOB_INTERVIEW: "job-interview",
  },
};

export const PLAN_FEATURE_LIST = [
  "Staff and Student Management",
  "Attendance Management",
  "Examination module",
  "Timetable Management",
  "Gate Tracking",
  "Fee and Payroll Management",
  "Communication & Notifications",
  "Syllabus Planning and Tracking",
  "Homework and Assignment Tracking",
  "Transportation & GPS Tracking",
  "Inventory management",
  "File manager",
  "Student medical records",
  "Circular",
  "Event & Calendar Scheduling",
  "Online classes",
  "Reports Management",
  "Document Locker",
  "Question Bank",
  "Library",
  "House Management",
  "Certificate & ID Card Management",
];

export const PLAN_ACCCESS_NOTE = {
  2: {
    BASIC: "Limited Access",
    STANDARD: "Full Access",
    PREMIUM: "Full Access",
  },
  4: {
    BASIC: "Students Only",
    STANDARD: "Students & Visitors",
    PREMIUM: "Students & Visitors",
  },
  6: {
    BASIC: "Limited group access",
    STANDARD: "Up to 10 groups",
    PREMIUM: "Unlimited group access",
  },
  1: { PREMIUM: "Biometric Integration" },
  11: { STANDARD: "1 GB Storage", PREMIUM: "2 GB Storage + Add-on options" },
};

export const PLANS_OVERVIEW = {
  BASIC: {
    subheading: "Core tools for managing daily academic tasks efficiently.",
    originalPrice: "10",
    price: 5,
    features: [0, 1, 2, 3, 4, 5, 6, 13, 14, 16, 19, 20],
  },
  STANDARD: {
    subheading:
      "Advanced features for better academic organization and control.",
    originalPrice: "14",
    price: 8,
    features: [0, 1, 2, 3, 4, 5, 6, 7, 11, 13, 14, 15, 16, 19, 20],
  },
  PREMIUM: {
    subheading:
      "All-in-one solution with automation and powerful academic modules.",
    originalPrice: "20",
    price: 10,
    features: [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21,
    ],
  },
};

export const task_status_type = [
  { id: "1", value: "1", name: "Lead Task" },
  { id: "0", value: "0", name: "Independent Task" },
];

/**
 * Generate avatar initials from user name
 * @param {string} name - User's full name
 * @returns {string} - First 2 characters of the name in uppercase
 */
export const generateAvatarInitials = (name) => {
  if (!name || typeof name !== 'string') return '??';
  
  const words = name.trim().split(/\s+/);
  if (words.length === 1) {
    // Single word - take first 2 characters
    return words[0].substring(0, 2).toUpperCase();
  } else {
    // Multiple words - take first character of first two words
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  }
};

/**
 * Generate a consistent background color for avatar based on name
 * @param {string} name - User's name
 * @returns {string} - CSS class for background color
 */
export const getAvatarBackgroundColor = (name) => {
  if (!name) return 'bg-gray-500';
  
  const colors = [
    'bg-blue-500',
    'bg-green-500', 
    'bg-purple-500',
    'bg-pink-500',
    'bg-indigo-500',
    'bg-yellow-500',
    'bg-red-500',
    'bg-teal-500',
    'bg-orange-500',
    'bg-cyan-500'
  ];
  
  // Use name length and first character to determine color
  const hash = name.length + name.charCodeAt(0);
  return colors[hash % colors.length];
};
